export default __webpack_public_path__ + "static/media/Rectangle 238.ff999395.svg";